/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, SetStateAction } from 'react';
import Stack from '@mui/material/Stack';
import MenuModal from '../components/modals/menu-modal';
import FormInput from '../components/form-elements/form-input';
import { useCreateGroupMutation } from '../services/groups.service';

interface Props {
  readonly setAnchor: React.Dispatch<SetStateAction<HTMLButtonElement | null>>;
  readonly anchor: HTMLButtonElement | null;
}

export default function GroupCreateForm({ ...props }: Props) {
  const [errorMessage, setErrorMessage] = useState('');
  const [createGroup, { error }] = useCreateGroupMutation();
  const nameRef = React.useRef({ getValue: () => '' });
  const descriptionRef = React.useRef({ getValue: () => '' });

  React.useEffect(() => {
    // @ts-ignore - update service mutation to expect 'data'
    setErrorMessage(error?.data?.errors[0]);
  }, [error]);

  const handleCreateGroup = async (e?: React.FormEvent) => {
    e?.preventDefault();
    const groupName = nameRef.current?.getValue()?.trim();

    if (!groupName) {
      setErrorMessage('A group name is required');
      return;
    }

    const res = await createGroup({
      name: groupName,
      description: descriptionRef.current?.getValue()?.trim(),
    }).unwrap();

    if (!res.data?.errors.length) {
      props.setAnchor(null);
    }
  };

  const handleCloseAction = () => {
    props.setAnchor(null);
    setErrorMessage('');
  };

  return (
    <MenuModal
      anchorEl={props.anchor}
      negative="Cancel"
      positive="Add"
      onClose={() => handleCloseAction()}
      onNegative={() => handleCloseAction()}
      onPositive={() => handleCreateGroup()}
      title="Create a new Group"
    >
      <Stack
        component="form"
        noValidate
        onSubmit={handleCreateGroup}
        autoComplete="off"
        sx={{ minWidth: '30vw' }}
      >
        <FormInput
          required
          variant="outlined"
          label="Name"
          name="name"
          onBlur={() => setErrorMessage('')}
          error={!!errorMessage}
          helperText={errorMessage || ' '}
          ref={nameRef}
        />
        <FormInput
          sx={{ mt: 0.75 }}
          variant="outlined"
          label="Description"
          name="description"
          multiline
          rows={4}
          ref={descriptionRef}
        />
      </Stack>
    </MenuModal>
  );
}
